export default __webpack_public_path__ + "static/realWorldImg5-e312d45278f88c1cabba5687614ef146.webp";